<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t("label.editCommune") }}
      </h3>
      <div class="pull-right box-tools">
        <a
          class="btn btn-default btn-sm"
          @click="$router.back()"
        >
          <i class="fa fa-arrow-circle-left" /> {{ $t("button.back") }}
        </a>
      </div>
    </div>
    <div class="box-body">
      <CommuneForm />
    </div>
  </div>
</template>

<script>
import CommuneForm from './Form'

export default {
  name: 'Edit',
  components: { CommuneForm },
  metaInfo () {
    return {
      title: this.$t('string.editNewCommune'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped></style>
